import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { installContactClickTracking } from "@/lib/analytics";

const cleanupContactTracking = installContactClickTracking();
if (module.hot) module.hot.dispose(cleanupContactTracking);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 60_000, refetchOnWindowFocus: false },
  },
});
const container = document.getElementById("root");
const normalizePath = (path) => path.replace(/\/+$/, "") || "/";
// Only hydrate a full React render for this route. An SPA fallback may contain
// the homepage HTML even when the browser requested a different URL.
const canHydrate =
  container.dataset.prerender === "react-v1" &&
  normalizePath(container.dataset.prerenderPath || "") === normalizePath(window.location.pathname) &&
  container.hasChildNodes();
const renderedYear = canHydrate && /^\d{4}$/.test(container.dataset.prerenderYear || "")
  ? Number(container.dataset.prerenderYear)
  : undefined;
const app = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App renderedYear={renderedYear} />
    </QueryClientProvider>
  </React.StrictMode>
);
if (canHydrate) {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}
